export const EsiaConsentBannerTexts = {
  title: 'Обновите своё согласие из Госуслуг',
  subtitle: 'Так вы увидите больше предложений',
  subtitleBeforeBreak: 'Так вы увидите больше',
  subtitleAfterBreak: 'предложений',
  button: 'Обновить',
  imageAlt: 'esia',
};
